/* eslint-disable */
export default {
  copy: 'Copiar',
} as const;

// @key: @#@"copy"@#@ @source: @#@"Copy"@#@
